import { render, staticRenderFns } from "./apartment-location-details.vue?vue&type=template&id=05e700f5&scoped=true&"
import script from "./apartment-location-details.ts?vue&type=script&lang=ts&"
export * from "./apartment-location-details.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-location-details.scss?vue&type=style&index=0&id=05e700f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e700f5",
  null
  
)

export default component.exports